import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminGuard } from './admin/admin.guard';
import { LoginComponent } from './Components/login/login.component';
import { MainComponent } from './Components/main/main.component';
import { ContenidoComponent } from './Components/main/contenido/contenido.component';

const routes: Routes = [
  { path: 'home', component: LoginComponent },
  { path: 'perfil', component: MainComponent,
  canActivate: [AdminGuard],
  children: [
    { path: "**", redirectTo: 'usuario'},
    { path: 'usuario/:id', component: ContenidoComponent }
  ]},
  { path: '**', redirectTo: "home" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
